module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/categories/shoulder-c0b4d9b97c04b13e7495f80a8a41c97a.png";